<template>
  <div class="list row">

    <!--
        <ProgressSpinner v-if="!ready"></ProgressSpinner>
    -->

    <div v-if="ready" class="col-md-12">
      <!-- Matchday | MatchesCount | MatchesTipCount | MatchDayPoints | DayRanking | SeasonRanking -->

      <DataTable :value="days" :scrollable="true" scrollHeight="flex"
                 class="p-datatable-sm"
                 :style="{height: '80vh'}"
                 selection-mode="single"
                 :row-class="rowClass"
                 @row-select="onRowSelect"
                 sortField="dayNumber" :sortOrder="1">

        <template #header>
          <div class="p-grid">
            <div class="p-col p-text-right">
              Gesamt:
              <Tag severity="info">{{ matchDaysOverallPoints }} Punkte</Tag>
              /
              <Tag severity="info">ø {{
                  matchDaysOverallPointsRate  | numFormat('0.00')
                }}
              </Tag>
            </div>
          </div>
        </template>

        <Column field="dayNumber" header="Spieltag"></Column>
        <Column field="points" header="Punkte">
          <template #body="slotProps">
            {{ getUserPoints(slotProps.data) }}
            <font-awesome-icon style="color: #FFD700;"
                               v-if="isWinner(slotProps.data)"
                               icon="medal"/>
          </template>
        </Column>
      </DataTable>

    </div>
    <back-to-top text="Nach oben"></back-to-top>
  </div>

</template>

<script>
import SeasonDataService from "../services/season-data.service";
import MatchDayDataService from "../services/match-day-data.service";
import Promise from "bluebird";

export default {
  name: "saison-list",
  data() {
    return {
      season: null,
      days: [],
      currentDay: null,
      currentMatchDayNumber: -1,
      atLeastOneFinished: false,
      matchDaysOverallPoints: 0,
      matchDaysOverallPointsRate: 0,
      currentIndex: -1,
      ready: false
    }
  },
  computed: {
    maintenanceUser: function () {
      return this.$store.state.sys.maintenanceUser;
    },
    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    },
    lastCalculatedMatchDay() {
      return this.$store.state.sys.lastCalcMatchDay;
    },
    subscription() {
      return this.$store.state.sys.subscription;
    }
  },
  methods: {
    retrieveMatches() {
      return new Promise((resolve, reject) => {
        console.log("Get matches for season:" + this.currentSeasonYear);
        SeasonDataService.getSeasonDays(
            {
              year: this.currentSeasonYear,
              maintenanceUser: this.maintenanceUser
            })
            .then(response => {
              // console.log(JSON.stringify(response.data));
              this.days = response.data.matchDays;
              return this.calculateOverallMatchDayPoints();
            })
            .then(() => {
              console.log("Points calculated.");
              resolve(true);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
      })
    },
    rowClass(data) {
      return data.dayNumber === this.currentMatchDayNumber ? 'row-accessories' : null;
    },
    getCurrentMatchDay() {
      return new Promise((resolve, reject) => {
        MatchDayDataService.getCurrentMatchDay()
            .then(apiGroup => {
              console.log(apiGroup);
              this.currentMatchDayNumber = apiGroup.data.GroupOrderID;
              resolve(apiGroup.data.GroupOrderID);
            })
            .catch(err => {
              console.log(err);
              reject(-1);
            })
      });
    },
    calculateOverallMatchDayPoints() {
      return new Promise((resolve, reject) => {
        if (this.days.length > 0) {
          this.matchDaysOverallPoints = 0;
          this.sumPoints()
              .then(success => {
                console.log("sumPoints result = " + success);  // => true
                return this.calculatePointRate();
              })
              .then(success => {
                if (success) {
                  console.log("Successfully calculated points rate")
                  this.ready = true;
                  resolve(true);
                }
              })
              .catch(err => {
                console.log(err);
              })
        } else {
          reject("No Days to calculate!");
        }
      });
    },
    sumPoints() {
      return new Promise((resolve, reject) => {
        Promise.each(this.days, (day) => {

          let userPointsDay = this.getUserPoints(day);

          if (userPointsDay != "ausstehend") {
            this.atLeastOneFinished = true;
            this.matchDaysOverallPoints += userPointsDay;
          }
        })
            .then(() => {
              // result is the array provided to the Promise.each call
              // console.log(JSON.stringify(result));
              resolve(true);
            })
            .catch(err => {
              reject(err);
            })
      });
    },
    calculatePointRate() {
      return new Promise((resolve, reject) => {

        this.$store.dispatch('sys/getSubscription')
            .then(() => {
              // console.log("PrepareStateData: " + JSON.stringify(this.internalSubscription));
              return this.$store.dispatch('sys/getLastCalculatedMatchDay', this.subscription.season);
            })
            .then(() => {
              this.matchDaysOverallPointsRate = this.matchDaysOverallPoints / this.lastCalculatedMatchDay;
              resolve(true);
            })
            .catch(err => {
              console.log("Error: " + err.message);
              reject(err);
            })
      });
    },
    setActiveMatch(day, index) {
      this.$confirm({
        message: "Soll das ausgewählte Spiel als Topspiel definiert werden?",
        button: {
          no: 'Nein',
          yes: 'Ja'
        },
        callback: confirm => {
          if (confirm) {
            console.log(day + " --> " + index);
          }
        }
      });
    },
    getUserPoints(day) {
      // console.log("getUserPoints: " + JSON.stringify(day));

      if (day && day.matchDayUserPoints.length > 0) {
        return day.matchDayUserPoints[0].userDayPoints;
      } else {
        return "ausstehend";
      }
    },
    isWinner(day) {
      if (day && day.matchDayUserPoints.length > 0) {
        if (day.matchDayUserPoints[0].userDayRanking === 1 && day.isFinished) {
          return true;
        }
      }
      return false;
    },
    onRowSelect(event) {
      console.log("Row: " + event.data.dayNumber);
      this.$emit('select-match-day', event.data.dayNumber);
    }
  },
  watch: {
    maintenanceUser: function () {
      this.retrieveMatches()
          .then(()=> {
            console.log("Matches retrieved.");
          })
          .catch(err => {
          console.log(err);
          })
    }
  },
  mounted() {
    this.$store.dispatch('sys/getCurrentSeasonYear');
    this.getCurrentMatchDay()
        .then(() => {
          return this.retrieveMatches();
        })
        .then(()=>{
          console.log("Matches retrieved.");
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 401) {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
          } else {
            this.content =
                (err.response && err.response.data) ||
                err.message ||
                err.toString();
          }
        })
  }
}
</script>

<style scoped>

/deep/ .row-accessories {
  background-color: rgba(0, 0, 0, .15) !important;
}

</style>